import { Appointment } from '@myapp/contract'
import { getAppointmentColors } from './timelineConstants'
import { shortLocation } from '../../../shared/helpers/address'

interface Props {
  appointment: Appointment
  onClick?: () => void
}

function formatTime(iso: string): string {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const WeekAppointmentPill = ({ appointment, onClick }: Props) => {
  const workStart = new Date(appointment.actualStart ?? appointment.plannedStart)
  const workDuration = appointment.actualWorkDuration ?? appointment.plannedWorkDuration
  const workEnd = new Date(workStart.getTime() + workDuration * 60_000)

  const ext = appointment.workOrder?.external
  const location = shortLocation(ext)
  const label = `${formatTime(workStart.toISOString())}–${formatTime(workEnd.toISOString())}${location ? ` ${location}` : ''}`
  const { workColor, travelColor } = getAppointmentColors(appointment.status)

  const tooltipParts = [
    label,
    ext ? `Nr. ${ext.auftragJahr}/${ext.auftragNr}` : null,
    ext?.gewerkeText ?? null,
    ext?.leistungText ?? null,
    ext?.mieter?.name ?? null,
  ].filter(Boolean)
  const tooltip = tooltipParts.join(' · ')

  return (
    <div
      className="flex items-center gap-0.5 rounded px-1 py-0.5 text-[11px] leading-tight text-white truncate cursor-pointer"
      style={{ backgroundColor: workColor }}
      onMouseDown={(e) => {
        if (onClick) {
          e.stopPropagation()
          onClick()
        }
      }}
      title={tooltip}
    >
      <span
        className="w-1 self-stretch rounded-sm shrink-0"
        style={{ backgroundColor: travelColor }}
      />
      <span className="truncate">{label}</span>
    </div>
  )
}
